import { render, staticRenderFns } from "./ConfirmArchiving.vue?vue&type=template&id=56a82a74&"
import script from "./ConfirmArchiving.vue?vue&type=script&lang=js&"
export * from "./ConfirmArchiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports